document.addEventListener('DOMContentLoaded', function() {
    const carouselRoot = document.getElementById('ProductImageCarousel');
    if (!carouselRoot) return;

    const hotspotButtons = carouselRoot.querySelectorAll('.hotspot-button');
    if (!hotspotButtons.length) return;

    // Create fixed layer once (outside Slick so it cannot be clipped)
    let layer = document.querySelector('.hotspot-tooltip-layer');
    if (!layer) {
        layer = document.createElement('div');
        layer.className = 'hotspot-tooltip-layer';
        document.body.appendChild(layer);
    }

    let activeBtn = null;

    function clearLayer() {
        layer.innerHTML = '';
    }

    function closeAllHotspots() {
        hotspotButtons.forEach(function(btn) {
        btn.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');

        // keep original tooltips inactive (they stay in-slide)
        const id = btn.getAttribute('data-hotspot');
        const tip = carouselRoot.querySelector('[data-hotspot-tooltip="' + id + '"]');
        if (tip) {
            tip.classList.remove('active');
            tip.setAttribute('aria-hidden', 'true');
        }
        });

        clearLayer();
        activeBtn = null;
        carouselRoot.classList.remove('hotspot-open');
        window.removeEventListener('scroll', onReposition, true);
        window.removeEventListener('resize', onReposition);
    }

    function positionPortaledTooltip(btn, tipEl) {
        const r = btn.getBoundingClientRect();
        const margin = 12;

        // Use innerWidth to avoid any matchMedia quirks in Shopify preview tools
        const isMobile = window.innerWidth <= 991;

        const x = r.left + (r.width / 2);

        // reset
        tipEl.classList.remove('is-below');

        if (isMobile) {
        // MOBILE: always below
        tipEl.classList.add('is-below');
        tipEl.style.left = x + 'px';
        tipEl.style.top  = (r.bottom + margin) + 'px';
        } else {
        // DESKTOP: default above
        tipEl.style.left = x + 'px';
        tipEl.style.top  = (r.top - margin) + 'px';

        // Flip below if it would go off-screen top
        const tr = tipEl.getBoundingClientRect();
        if (tr.top < 8) {
            tipEl.classList.add('is-below');
            tipEl.style.top = (r.bottom + margin) + 'px';
        }
        }

        // Clamp horizontally within viewport
        const tr2 = tipEl.getBoundingClientRect();
        const pad = 10;

        if (tr2.left < pad) {
        tipEl.style.left = (pad + (tr2.width / 2)) + 'px';
        } else if (tr2.right > window.innerWidth - pad) {
        tipEl.style.left = (window.innerWidth - pad - (tr2.width / 2)) + 'px';
        }

        // --- Arrow alignment: point arrow at the hotspot center ---
        const tipRect = tipEl.getBoundingClientRect();
        const hotspotCenterX = r.left + (r.width / 2);

        // Arrow position inside tooltip (in px)
        let arrowLeft = hotspotCenterX - tipRect.left;

        // Clamp arrow so it doesn't go beyond tooltip padding/edges
        const arrowPad = 18; // keep triangle away from rounded corners
        arrowLeft = Math.max(arrowPad, Math.min(tipRect.width - arrowPad, arrowLeft));

        tipEl.style.setProperty('--arrow-left', `${arrowLeft}px`);      
    }

    function openHotspot(btn) {
        const id = btn.getAttribute('data-hotspot');
        const original = carouselRoot.querySelector('[data-hotspot-tooltip="' + id + '"]');
        if (!original) return;

        clearLayer();

        // Clone the tooltip into the fixed layer
        const tip = original.cloneNode(true);
        tip.classList.add('active');
        tip.setAttribute('aria-hidden', 'false');
        layer.appendChild(tip);

        // Stop clicks inside tooltip from closing it
        tip.addEventListener('click', function(e) {
        e.stopPropagation();
        });

        positionPortaledTooltip(btn, tip);

        activeBtn = btn;
        carouselRoot.classList.add('hotspot-open');

        window.addEventListener('scroll', onReposition, true);
        window.addEventListener('resize', onReposition);
    }

    function onReposition() {
        if (!activeBtn) return;
        const portaled = layer.querySelector('.hotspot-tooltip');
        if (!portaled) return;
        positionPortaledTooltip(activeBtn, portaled);
    }

    hotspotButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
        const slide = btn.closest('.slick-slide');
        if (slide && slide.classList.contains('slick-cloned')) return;

        e.preventDefault();
        e.stopPropagation();

        const wasActive = btn.classList.contains('active');
        closeAllHotspots();

        if (!wasActive) {
            btn.classList.add('active');
            btn.setAttribute('aria-expanded', 'true');
            openHotspot(btn);
        }
        });
    });

    document.addEventListener('click', function() {
        closeAllHotspots();
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
        closeAllHotspots();
        }
    });
});